import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NETWORK } from '@arianee/arianeejs';
import moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EventLoggerService } from '../../../../../providers/event-logger/event-logger-service';
import { NotificationService } from '../../../../../providers/notification-service/notification.service';
import {
	NotificationGroup,
	notificationsMapper,
} from '../../mappers/notification-mapper';

@Component({
	selector: 'app-notifications-new',
	templateUrl: './notifications-new.component.html',
	styleUrls: ['./notifications-new.component.scss'],
})
export class NotificationsNewComponent implements OnInit, OnDestroy {
	notifications: NotificationGroup[] = undefined;
	private $destroy: Subject<void> = new Subject<void>();
	constructor(
		private eventLogger: EventLoggerService,
		private router: Router,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		this.eventLogger.logScreen('notif', {});
		this.notificationService.$notifications
			.pipe(takeUntil(this.$destroy))
			.subscribe((notifications) => {
				const sortedNotifications = notifications.sort((left, right) =>
					moment(right.time).diff(moment(left.time)),
				);
				this.notifications = notificationsMapper(sortedNotifications);
			});
	}

	ngOnDestroy(): void {
		this.$destroy.next();
		this.$destroy.complete();
	}

	async onNotificationClick(
		certificateId: string,
		isRead: boolean,
		messageId: string,
		network: NETWORK,
	) {
		await this.router.navigate([`/notification/${network}/${certificateId}`], {
			queryParams: {
				isRead: isRead,
				messageId: messageId,
			},
			skipLocationChange: true,
		});
	}
}
